import { render, staticRenderFns } from "./holes-empty.vue?vue&type=template&id=280b5b05"
import script from "./holes-empty.vue?vue&type=script&lang=js"
export * from "./holes-empty.vue?vue&type=script&lang=js"
import style0 from "./holes-empty.vue?vue&type=style&index=0&id=280b5b05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports